module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//empty_1.png?v=857a276d";